import React from 'react';
import { Box, Grid, Typography, Paper } from '@mui/material';

const WhatIf = () => (
    <Box
        sx={{
            width: '100%',
            bgcolor: '#fff',
            py: 6,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}
    >
        <Typography
            variant="h2"
            component="h2"
            sx={{
                fontFamily: 'inherit',
                fontWeight: 400,
                fontSize: { xs: 32, md: 48 },
                color: 'rgba(28, 30, 46, 1)',
                mb: 4,
                textAlign: 'center',
            }}
        >
            <strong>What If You Could...</strong>
        </Typography>
        {/* Card-like layer for the whole section */}
        <Paper
            elevation={3}
            sx={{
                mx: 'auto',
                px: 2,
                py: 4,
                borderRadius: 4,
                position: 'relative',
                overflow: 'visible',
                width: '100%',
            }}
        >
            <Grid container spacing={4} justifyContent="center" alignItems="center">
                <Grid item xs={12} md={4}>
                    <Paper elevation={0} sx={{ bgcolor: 'transparent', boxShadow: 'none' }}>
                        <Box sx={{ fontFamily: 'inherit', fontSize: 18, color: 'text.secondary' }}>
                            <Typography paragraph>
                                <strong>Imagine mornings</strong> that start with calm instead of chaos.
                            </Typography>
                            <Typography paragraph>
                                <strong>Imagine your child learning</strong> to name their feelings and handle them with grace.
                            </Typography>
                            <Typography paragraph>
                                <strong>Imagine family moments</strong> that feel peaceful, joyful, and connected.
                            </Typography>
                            <Typography paragraph>
                                <strong>
                                    That’s the reality waiting on the other side of <em>Happy US</em>.
                                </strong>
                            </Typography>
                            <Typography>
                                A home filled with more laughter, compassion, and emotional strength, one small shift at a time.
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box sx={{ position: 'relative', width: '100%', maxWidth: 400, height: 'auto' }}>
                        {/* Green overlay */}
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                bgcolor: 'custom.green',
                                borderRadius: 2,
                                zIndex: 1,
                            }}
                        />
                        <Box
                            component="img"
                            src="/assets/untitled-design-23.png"
                            alt="Calm morning"
                            sx={{ width: '100%', maxWidth: 400, height: 'auto', borderRadius: 2, boxShadow: 2, position: 'relative', zIndex: 2 }}
                            loading="lazy"
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box sx={{ position: 'relative', width: '100%', maxWidth: 400, height: 'auto' }}>
                        {/* Green overlay */}
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                bgcolor: 'custom.green',
                                borderRadius: 2,
                                zIndex: 1,
                            }}
                        />
                        <Box
                            component="img"
                            src="/assets/untitled-design-32.png"
                            alt="Family connection"
                            sx={{ width: '100%', maxWidth: 400, height: 'auto', borderRadius: 2, boxShadow: 2, position: 'relative', zIndex: 2 }}
                            loading="lazy"
                        />
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    </Box>
);

export default WhatIf;